
import {filter} from 'rxjs/operators';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ChatOnboardingService } from '../services/chat-onboarding.service';
import { BehaviorSubject } from 'rxjs';
import { StorageService } from '../../../services/storage.service';

@Component({
  selector: 'chat-onboarding',
  templateUrl: './chat-onboarding.component.html',
  styleUrls: ['./chat-onboarding.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ChatOnboardingComponent implements OnInit {
  public statusChat = new BehaviorSubject(false);
  public active: boolean = false;

  constructor(
    public router: Router, 
    public chatOnboardingService: ChatOnboardingService,
    ) { }

  ngOnInit() {
    this.routerVerification();
    this.openedChatVerification();
  }

  public routerVerification() {
    const answered = StorageService.getCookie('chat-onboarding-everything-complete') === 'true';
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd))
      .subscribe((event:NavigationEnd) => {
        this.active = this.chatOnboardingService.activeService(event.url) && !answered;
        this.closeChat(event.url);
      });
  }

  public openedChatVerification() {
    const closed = StorageService.getCookie('chat-onboarding-closed-preference') === 'true';
    this.statusChat.next(!closed);
  }

  public closeChat(currentUrl: string) {
    if(this.chatOnboardingService.isMobile) {
      this.statusChat.next(!this.chatOnboardingService.closeOnSelectedPage(currentUrl));
    }
  }
}
